import PartsInputSearch from '@/components/_common/PartsInputSearch';
import ServicesInputSearch from '@/components/_common/ServicesInputSearch';
import { WorkorderImportItem } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row, Typography } from 'antd';

type Props = Omit<ModalProps, 'onCancel'> & {
  item?: WorkorderImportItem;
  onConfirm: (data: {
    name: string;
    id: number;
    code: string;
    manufacturingCode: string;
  }) => void;
  onCancel: VoidFunction;
};

const ImportChangeItemsModal: React.FC<Props> = ({
  item,
  onConfirm,
  ...props
}) => {
  const [form] = Form.useForm();

  const itemTypeLabel = {
    [WorkOrderItemType.Part]: 'Peça',
    [WorkOrderItemType.Service]: 'Serviço',
    [WorkOrderItemType.Undefined]: '',
    [WorkOrderItemType.Kit]: 'Kit',
    [WorkOrderItemType.Benefit]: 'Benefícios',
    [WorkOrderItemType.Bosch]: 'Bosch',
    [WorkOrderItemType.Porto]: 'Porto',
  };

  const isPart = item?.type === WorkOrderItemType.Part;

  const ruleRequired = useDefaultEmptyFieldError();

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      onConfirm(values);
      handleClose();
    } catch {}
  }

  function handleClose() {
    form.resetFields();
    props.onCancel();
  }

  return (
    <Modal
      {...props}
      width={500}
      title={`Troca de ${itemTypeLabel[item?.type as WorkOrderItemType]}`}
      okText="Substituir"
      onOk={handleSubmit}
      onCancel={handleClose}
    >
      <Typography.Text>{`Selecione ${
        isPart ? 'a peça' : 'o serviço'
      } de substituição`}</Typography.Text>

      <Form form={form}>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col span={24}>
            <div>
              <Typography.Text>{`${
                isPart ? 'Peça' : 'Serviço'
              }  atual:`}</Typography.Text>
            </div>
            <Input value={item?.description} disabled />
          </Col>

          <Col span={24} style={{ height: '100%' }}>
            <div>
              <Typography.Text>{`${
                isPart ? 'Peça' : 'Serviço'
              } de troca:`}</Typography.Text>
            </div>

            <Form.Item hidden name="id">
              <Input />
            </Form.Item>

            <Form.Item hidden name="code">
              <Input />
            </Form.Item>

            <Form.Item hidden name="manufacturingCode">
              <Input />
            </Form.Item>

            <Form.Item name="name" noStyle rules={[ruleRequired]}>
              {isPart ? (
                <PartsInputSearch
                  fieldNameId="id"
                  onPartSelect={(part) => {
                    form.setFieldValue('id', part.id);
                    form.setFieldValue('name', part.name);
                    form.setFieldValue('code', part?.barCode);
                    form.setFieldValue(
                      'manufacturingCode',
                      part.manufacturingCode,
                    );
                  }}
                />
              ) : (
                <ServicesInputSearch
                  fieldNameId="id"
                  onServiceSelect={(task) => {
                    form.setFieldValue('id', task.id);
                    form.setFieldValue('name', task.description);
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ImportChangeItemsModal;
